import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
export const UnderlineHead = (props) => {
    const { backgroundClass, className = '', tagName: Tag = 'h3', title } = props;
    return (_jsxs(Tag, Object.assign({ className: clsx('border-0 border-b-2 border-solid border-b-gray-300', className) }, { children: [_jsx(Text, Object.assign({ color: 'primary' }, { children: title })), _jsx("hr", { className: clsx(backgroundClass, 'w-[216px] h-[2px] mt-8 border-none translate-y-[2px]') })] })));
};
